import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  id: string;
  data: any; //TODO: fix type;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  id: "",
  data: null,
};

const getRequestLeaveDetailSlice = createSlice({
  name: "getRequestLeaveDetail",
  initialState,
  reducers: {
    setRequestLeaveDetailId: (state, action: PayloadAction<string>) => {
      state.id = action.payload;
    },
    resetRequestLeaveDetailId: (state) => {
      state.id = "";
    },
    getRequestLeaveDetailStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getRequestLeaveDetailSuccess: (state, action: PayloadAction<any>) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },

    getRequestLeaveDetailFailed: (state, action) => {
      state.status = ReduxStateType.ERROR;
      state.data = action.payload;
    },
    updateDetailOrder: (state, action: PayloadAction<any>) => {
      if (!state.data) return;
      state.data.details = action.payload;
    },
    resetRequestLeaveDetail: () => {
      return { ...initialState };
    },
  },
});

export const {
  setRequestLeaveDetailId,
  resetRequestLeaveDetailId,
  getRequestLeaveDetailStart,
  getRequestLeaveDetailSuccess,
  getRequestLeaveDetailFailed,
  resetRequestLeaveDetail,
  updateDetailOrder,
} = getRequestLeaveDetailSlice.actions;

export default getRequestLeaveDetailSlice.reducer;
